import { BackgroundImage } from '../../../../../../components/profile/Customize/BackgroundImage'
import { FC } from 'react'
import { PageType } from '@dtx-company/flow-codegen/src/page/typeUtils'
import { Stack } from '@dtx-company/design-system/src'
import { getLockedFieldFromTemplateConfig } from '../../../../../FlowpageTemplates/utils/getLockedFieldFromTemplateConfig'
import { useCurrentPage } from '@dtx-company/inter-app/src/redux/slices/utils/currentPage'
import { usePageTemplateEditorState } from '@dtx-company/inter-app/src/hooks/usePageTemplateEditorState'

export const BackgroundMenu: FC<{ pageTheme: PageType['theme'] }> = ({ pageTheme }) => {
  const page = useCurrentPage()
  const { isTemplateEditor } = usePageTemplateEditorState()

  const disabled =
    !isTemplateEditor &&
    getLockedFieldFromTemplateConfig({
      templateConfig: pageTheme?.templateConfig,
      field: 'backgroundImgUrl'
    })
  return (
    <Stack sx={theme => ({ p: theme.spacing(4, 0.75) })}>
      <BackgroundImage disabled={disabled} page={page || undefined} />
    </Stack>
  )
}
